import { render, staticRenderFns } from "./myBreadcrumb.vue?vue&type=template&id=354342a6&scoped=true&"
import script from "./myBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./myBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./myBreadcrumb.vue?vue&type=style&index=0&id=354342a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354342a6",
  null
  
)

export default component.exports